module.exports = "/cyber/_next/static/images/buySteamSlide-7e709372e58c56346e8a1a844e5b56f5.jpg";